import { useReferrerAPI } from '@hooks/referrer/useReferrerAPI';
import type { AttendeeQueryType } from '@interfaces/session';
import { companyInfo } from '@stores/atoms/company';
import { loginInfo } from '@stores/atoms/login';
import { useSetAtom } from 'jotai';

export function useAuthentication() {
  const { fetchCompanyInfo, fetchAttendee } = useReferrerAPI();
  const setCompanyInfo = useSetAtom(companyInfo);
  const setLoginInfo = useSetAtom(loginInfo);

  const authenticateUser = async ({
    name,
    certificationCode,
    apiUrl,
  }: Pick<AttendeeQueryType, 'name' | 'certificationCode'> & {
    apiUrl: string;
  }) => {
    const companyInfoResult = await fetchCompanyInfo(apiUrl);
    if (!companyInfoResult.status) return false;

    const attendeeResult = await fetchAttendee({
      name,
      certificationCode,
      apiUrl,
    });
    if (!attendeeResult.status) return false;

    setCompanyInfo(companyInfoResult.data);
    setLoginInfo(attendeeResult.data);

    return true;
  };

  return { authenticateUser };
}
